import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher = ({ className = '', style = {} }) => {
  const { currentLanguage, changeLanguage, availableLanguages: _availableLanguages } = useLanguage();

  const getFlag = (languageCode) => {
    switch (languageCode) {
      case 'en':
        return '🇺🇸'; // USA flag
      case 'ar':
        return '🇸🇦'; // Saudi Arabia flag
      default:
        return '🌐';
    }
  };

  const getLanguageName = (languageCode) => {
    // Show the opposite language (the one to switch TO)
    switch (languageCode) {
      case 'en':
        return 'عربي'; // Show Arabic when current is English
      case 'ar':
        return 'Eng'; // Show English when current is Arabic
      default:
        return languageCode;
    }
  };

  const toggleLanguage = () => {
    const newLanguage = currentLanguage === 'en' ? 'ar' : 'en';
    changeLanguage(newLanguage);
  };

  return (
    <div className={`language-switcher ${className}`} style={style}>
      <button
        onClick={toggleLanguage}
        style={{
          color: 'white',
          textDecoration: 'none',
          fontSize: '14px',
          transition: 'all 0.3s ease',
          fontWeight: '600',
          padding: '10px 20px',
          borderRadius: '25px',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          userSelect: 'none',
          WebkitUserSelect: 'none',
          MozUserSelect: 'none',
          msUserSelect: 'none',
          WebkitTouchCallout: 'none',
          WebkitTapHighlightColor: 'transparent',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'Inter, sans-serif',
          outline: 'none',
          minWidth: '90px',
          width: '90px',
          maxWidth: '90px',
          height: '45px',
          minHeight: '45px',
          maxHeight: '45px',
          boxSizing: 'border-box',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          lineHeight: '1',
          ...style
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
          e.target.style.borderColor = 'rgba(255, 255, 255, 0.4)';
          e.target.style.transform = 'translateY(-1px)';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
          e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
          e.target.style.transform = 'translateY(0)';
        }}
      >
        <span style={{ 
          fontSize: '13px',
          fontWeight: '600',
          fontFamily: "'Inter', sans-serif",
          letterSpacing: currentLanguage === 'en' ? '0' : '0.05em',
          userSelect: 'none',
          WebkitUserSelect: 'none',
          MozUserSelect: 'none',
          msUserSelect: 'none',
          WebkitTouchCallout: 'none',
          WebkitTapHighlightColor: 'transparent',
          pointerEvents: 'none'
        }}>
          {getLanguageName(currentLanguage)}
        </span>
      </button>
    </div>
  );
};

export default LanguageSwitcher;
